import type { ContextFormFieldBaseProps } from '@bambi/component-library/src/components/forms/context/ContextFormFieldBaseProps';
import type { FormFieldControllerRulesProps } from '@bambi/component-library/src/components/forms/context/FormFieldController';
import { FormFieldController } from '@bambi/component-library/src/components/forms/context/FormFieldController';

import { CoreFormFieldSwitch } from '../core/CoreFormFieldSwitch';

export const ContextFormFieldSwitch = ({
  fieldPath,
  rules,
  label,
  srOnlyLabel,
  helperText,
  colSpan,
  disabled,
}: ContextFormFieldBaseProps & { srOnlyLabel?: boolean }) => {
  return (
    <FormFieldController
      name={fieldPath}
      rules={rules as FormFieldControllerRulesProps}
    >
      {({ field }) => (
        <CoreFormFieldSwitch
          inputProps={{ id: fieldPath, ...field, disabled }}
          label={rules?.required ? `${label} *` : label}
          srOnlyLabel={srOnlyLabel}
          helperText={helperText}
          colSpan={colSpan}
        />
      )}
    </FormFieldController>
  );
};
